module.exports = __webpack_public_path__ + "static/beach_break_sea_oats-59d6163e71fbf55e260d2820a0b3a3b1.jpg";